import { doc, getDoc, setDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { auth, db } from "../firebase";

const styles = {
  screen: { minHeight: "100vh", backgroundColor: "#F4F6F9", fontFamily: "system-ui, sans-serif" },
  main: { marginLeft: 220, padding: 24 },
  title: { fontSize: 22, fontWeight: "700", color: "#0A2D5A", marginBottom: 4 },
  sub: { fontSize: 13, color: "#888", marginBottom: 24 },
  card: { backgroundColor: "white", borderRadius: 12, border: "0.5px solid #e0e0e0", padding: 24, maxWidth: 560 },
  sectionTitle: { fontSize: 13, fontWeight: "700", color: "#888", textTransform: "uppercase", letterSpacing: 1, margin: "20px 0 12px" },
  field: { marginBottom: 16 },
  label: { display: "block", fontSize: 13, fontWeight: "600", color: "#444", marginBottom: 6 },
  input: { width: "100%", padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", fontSize: 15, boxSizing: "border-box", outline: "none" },
  roRow: { display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "0.5px solid #f0f0f0" },
  roLabel: { color: "#888", fontSize: 13 },
  roValue: { color: "#111", fontSize: 14, fontWeight: "600" },
  saveBtn: { marginTop: 20, backgroundColor: "#E8620A", color: "white", border: "none", borderRadius: 8, padding: "12px 24px", fontSize: 15, fontWeight: "600", cursor: "pointer" },
  toast: { position: "fixed", bottom: 32, left: "50%", transform: "translateX(-50%)", backgroundColor: "#0A2D5A", color: "white", padding: "12px 24px", borderRadius: 10, fontSize: 14, fontWeight: "600", zIndex: 2000 },
  hint: { fontSize: 12, color: "#888", marginTop: 6 },
};

export default function AdminProfile() {
  const user = auth.currentUser;
  const [form, setForm] = useState({ name: "", phone: "", senderName: "", senderEmail: "", supportEmail: "" });
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const load = async () => {
      if (!user) return;
      try {
        const snap = await getDoc(doc(db, "adminSettings", user.uid));
        if (snap.exists()) setForm(function (prev) { return Object.assign({}, prev, snap.data()); });
      } catch (e) { console.error("load admin settings", e); }
    };
    load();
  }, [user]);

  const change = (f, v) => setForm(function (prev) { const n = Object.assign({}, prev); n[f] = v; return n; });

  const save = async () => {
    if (!user) return;
    setSaving(true);
    try {
      await setDoc(doc(db, "adminSettings", user.uid), Object.assign({}, form, { updatedAt: new Date().toISOString() }), { merge: true });
      setToast("Profile saved.");
    } catch (e) { console.error("save admin settings", e); setToast("Save failed."); }
    setSaving(false);
    setTimeout(function () { setToast(null); }, 3000);
  };

  return (
    <div style={styles.screen}>
      <Sidebar admin />
      <div style={styles.main}>
        {toast ? <div style={styles.toast}>{toast}</div> : null}
        <div style={styles.title}>Admin Profile</div>
        <div style={styles.sub}>Your administrator account and messaging identity.</div>
        <div style={styles.card}>
          <div style={styles.roRow}><span style={styles.roLabel}>Login Email</span><span style={styles.roValue}>{user ? user.email : "-"}</span></div>
          <div style={styles.roRow}><span style={styles.roLabel}>Role</span><span style={styles.roValue}>Administrator</span></div>

          <div style={styles.sectionTitle}>Contact</div>
          <div style={styles.field}><label style={styles.label}>Name</label><input style={styles.input} value={form.name} onChange={(e) => change("name", e.target.value)} placeholder="Your name" /></div>
          <div style={styles.field}><label style={styles.label}>Phone</label><input style={styles.input} value={form.phone} onChange={(e) => change("phone", e.target.value)} placeholder="Your phone number" /></div>

          <div style={styles.sectionTitle}>Messaging Identity</div>
          <div style={styles.field}><label style={styles.label}>Sender Name</label><input style={styles.input} value={form.senderName} onChange={(e) => change("senderName", e.target.value)} placeholder="Medicare Plan Guardian Support" /><div style={styles.hint}>Display name on messages sent to agents.</div></div>
          <div style={styles.field}><label style={styles.label}>Sender / Reply-To Email</label><input style={styles.input} type="email" value={form.senderEmail} onChange={(e) => change("senderEmail", e.target.value)} placeholder="support@medicareplanguardian.com" /><div style={styles.hint}>Address agent-facing messages are sent from.</div></div>
          <div style={styles.field}><label style={styles.label}>Support Email</label><input style={styles.input} type="email" value={form.supportEmail} onChange={(e) => change("supportEmail", e.target.value)} placeholder="support@medicareplanguardian.com" /><div style={styles.hint}>Inbox you monitor for agent support.</div></div>

          <button style={styles.saveBtn} onClick={save} disabled={saving}>{saving ? "Saving..." : "Save Profile"}</button>
        </div>
      </div>
    </div>
  );
}
